"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _slate = require("slate");

var _trailingSpace = _interopRequireDefault(require("../utils/trailingSpace"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(type, currentTextNode, matched, change) {
  var matchedLength = matched[0].length;
  return change.deleteAtRange(_slate.Range.create({
    anchorKey: currentTextNode.key,
    focusKey: currentTextNode.key,
    anchorOffset: matched.index,
    focusOffset: matched.index + matchedLength + 1
  })).insertText(matched[1]).extend(0 - matched[1].length).wrapInline({
    type: type,
    data: {
      href: matched[2]
    }
  }).collapseToEnd();
}